import { useMutation } from '@tanstack/react-query';
import { getShareToken, sendReportLinkWithSms } from 'modules/report/services/sms-service';

const useGetShareToken = () => {
  return useMutation({
    mutationFn: getShareToken
  });
};

const useSendSMS = (setDelivered) => {
  const mutateSendSMS = useMutation({
    mutationFn: sendReportLinkWithSms,
    onSuccess: (res) => {
      if (res.status === 200) setDelivered(true);
    }
  });
  return mutateSendSMS;
};

export { useSendSMS, useGetShareToken };
